import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    text: String
  }

  async copy() {
    if (!this.hasTextValue) return

    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(this.textValue)
    } else {
      this.copyWithFallback()
    }

    const originalText = this.element.textContent
    this.element.textContent = "Copiado"

    window.setTimeout(() => {
      this.element.textContent = originalText
    }, 1500)
  }

  copyWithFallback() {
    const textarea = document.createElement("textarea")
    textarea.value = this.textValue
    textarea.setAttribute("readonly", "")
    textarea.style.position = "absolute"
    textarea.style.left = "-9999px"
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand("copy")
    document.body.removeChild(textarea)
  }
}
